import React from 'react';
import '../../../assets/scss/deliverables.scss';
import moment from 'moment';
const DeliverablesTable = ({ dataSource, columns, showNoDateData,onClickView }) => {
	const groupedData = { blank: [] };
	for (const key of dataSource) {
		if (key.dueDate && !groupedData[key.dueDate]) {
			groupedData[key.dueDate] = [];
			groupedData[key.dueDate].push(key);
		} else if (!key.dueDate) {
			groupedData.blank.push(key);
		} else {
			groupedData[key.dueDate].push(key);
		}
	}
	if (!groupedData?.blank?.length) {
		delete groupedData.blank;
	}
	dataSource = Object.keys(groupedData);

	function createRows(date) {
		const data = groupedData[date];

		const mon = [
			'Jan',
			'Feb',
			'Mar',
			'Apr',
			'May',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Oct',
			'Nov',
			'Dec',
		];
		let dateData, day, month;
		if (date !== 'blank') {
			date = moment(date.toString(), 'YYYYMMDD').format('YYYY-MM-DD');
			dateData = new Date(date);
			day = dateData.getDate();
			month = mon[dateData.getMonth()];
		}

		return (
			<>
				{!showNoDateData ? (
					<tr style={{ backgroundColor: '#414141' }}>
						<td
							className="hello"
							colSpan={columns.length}
							style={{
								color: date === 'blank' ? '#414141' : '#E4E5E6',
								fontSize: '16px',
								fontStyle: 'normal',
								fontWeight: '500',
								lineHeight: '20px',
								letterSpacing: '-0.3px',
							}}
						>
							{date === 'blank' ? 'blank' : `${day} ${month}`}
						</td>
					</tr>
				) : (
					''
				)}

				{data.map((d) => {
					return (
						<tr onClick={()=>onClickView(d)}>
							{columns.map((col, index) => {
								if (col.renderis) {
									return <td>{col.renderis(d)}</td>;
								}
								return <td>{d[col.dataIndex]}</td>;
							})}
						</tr>
					);
				})}
			</>
		);
	}

	return (
		<div className="DeliverablesTable" style={{ overflowX: 'auto', maxHeight: '65vh',position:'relative'}}>
			<table style={{ width: '100%', overflowY: 'auto' }}>
				<thead>
					<tr>
						{columns.map((ele) => (
							<td style={{ color: '#B0B0B0' }}>{ele.title}</td>
						))}
					</tr>
				</thead>
				<tbody>{dataSource.map((date) => createRows(date))}</tbody>
			</table>
			
		</div>
	);
};

export default DeliverablesTable;
